import { fetchWrapper } from "../../utils/fetchWrapper";

import globalState from "../global-state";

import { getLojaFetch, gotoFaseLoja } from "./loja";
import { gotoFaseProposta } from "./proposta";


export enum Fases {
    Loja = 1,
    Proposta = 2
}

export interface IProponente {
    nome?: string
    cnpj?: string
}

export interface ICorretora {
    susep?: string
    sucursal?: string
    bancos?: string
}

export interface ISimulacaoState {
    idSimulacao?: number
    fase?: number
    cnpjParceria?: number
    codProdutor?: string
    idFaseMag?: string
    proponente?: IProponente
    corretora?: ICorretora
    naoExistePa?: boolean
}

export const getSimulacaoFetch = () =>
    fetchWrapper<ISimulacaoState>("/api/simulacao");

export const initSimulacao = async () => {
    const simulacao = await getSimulacaoFetch();
    globalState.simulacao.set(simulacao);

    const response = await getLojaFetch();
    globalState.faseLoja.set(response);

    switch(simulacao.fase) {
        case Fases.Loja:
            await gotoFaseLoja();
            break;
        case Fases.Proposta:
            await gotoFaseProposta();
            break
    }
}
